import React from "react";

type ErrorIconProps = {
  size?: 16 | 32;
};

export const ErrorIcon: React.FC<ErrorIconProps> = ({ size = 16 }) => {
  if (size === 32) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M17.3334 17.3337H14.6667V9.33366H17.3334V17.3337ZM17.3334 22.667H14.6667V20.0003H17.3334V22.667ZM16.0001 2.66699C14.2491 2.66699 12.5153 3.01187 10.8976 3.68193C9.27996 4.35199 7.81011 5.33412 6.57199 6.57223C4.07151 9.07272 2.66675 12.4641 2.66675 16.0003C2.66675 19.5365 4.07151 22.9279 6.57199 25.4284C7.81011 26.6665 9.27996 27.6487 10.8976 28.3187C12.5153 28.9888 14.2491 29.3337 16.0001 29.3337C19.5363 29.3337 22.9277 27.9289 25.4282 25.4284C27.9287 22.9279 29.3334 19.5365 29.3334 16.0003C29.3334 14.2494 28.9885 12.5156 28.3185 10.8979C27.6484 9.2802 26.6663 7.81035 25.4282 6.57223C24.1901 5.33412 22.7202 4.35199 21.1025 3.68193C19.4849 3.01187 17.751 2.66699 16.0001 2.66699Z"
          fill="var(--inzeloop-ds-color-status-negative-accent)"
        />
      </svg>
    );
  }

  // default 16x16 icon
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.66671 8.66634H7.33337V4.66634H8.66671V8.66634ZM8.66671 11.333H7.33337V9.99967H8.66671V11.333ZM8.00004 1.33301C7.12456 1.33301 6.25765 1.50545 5.44882 1.84048C4.63998 2.17551 3.90505 2.66657 3.286 3.28563C2.03575 4.53587 1.33337 6.23156 1.33337 7.99967C1.33337 9.76778 2.03575 11.4635 3.286 12.7137C3.90505 13.3328 4.63998 13.8238 5.44882 14.1589C6.25765 14.4939 7.12456 14.6663 8.00004 14.6663C9.76815 14.6663 11.4638 13.964 12.7141 12.7137C13.9643 11.4635 14.6667 9.76778 14.6667 7.99967C14.6667 7.1242 14.4943 6.25729 14.1592 5.44845C13.8242 4.63961 13.3331 3.90469 12.7141 3.28563C12.095 2.66657 11.3601 2.17551 10.5513 1.84048C9.74243 1.50545 8.87552 1.33301 8.00004 1.33301Z"
        fill="var(--inzeloop-ds-color-control-error-text)"
      />
    </svg>
  );
};
